<template>
  <div>
    <infotip
      v-if="card.infotip"
      :id="card.infotip.id"
      :key="card.id + '-infotip'"
      :direction="card.infotip.direction"
      :text="card.infotip.text"
      :auto-open-on-first-days="card.infotip.autoOpenOnFirstDays"
      :highlight-target-element="card.infotip.highlightTargetElement"
    />
    <card
      v-if="card.visible"
      :id="card.id"
      :key="card.id"
      :title="card.title"
      :title-action="card.titleAction"
      :capitalize-subtitle="card.capitalizeSubtitle"
      :subtitle-regular="card.subtitle"
      :transparent-card="card.transparentCard"
      :class="{ 'card-disabled': !toggle.sampleTraceability }"
    >
      <component
        :is="card.component.name"
        v-if="card.component"
        :key="card.component.key"
        :content="card.component.content"
      />
      <infotip
        v-if="card.disabled"
        :id="card.id + '-disabled'"
        :key="card.id + '-infotip-disabled'"
        :text="
          card.disabledMessage || 'A funcionalidade está temporariamente em manutenção.'
        "
        :auto-open-on-first-days="false"
        :never-open-again-after-dismissed="false"
        :close-on-mouse-leave="true"
      />
    </card>
  </div>
</template>

<script>
import Card from '../Card'
import FastSearch from '../Widgets/FastSearch'
import Infotip from '@/components/common/infotip/Infotip'
import Moment from 'moment'

import { mapGetters, mapActions } from 'vuex'
import { TRACEABILITY_SEARCH_DATE } from '../../../enums'

export default {
  name: 'CardSearch',
  components: {
    card: Card,
    infotip: Infotip,
    'fast-search': FastSearch,
  },
  data() {
    return {
      card: {
        id: 'traceability-search',
        title: 'Minha Rotina - Busca',
        titleAction: this.navigateToSearchIcon,
        subtitle: 'Busque pelos seus exames e amostras',
        visible: true,
        disabled: false,
        capitalizeSubtitle: true,
        infotip: {
          direction: 'top',
          id: 'busca',
          text: 'Busque aqui para saber o status atual de suas amostras!',
          autoOpenOnFirstDays: true,
          highlightTargetElement: true,
        },
        component: {
          name: 'fast-search',
        },
      },
    }
  },
  computed: {
    ...mapGetters(['toggle']),
  },
  methods: {
    ...mapActions(['resetTraceabilityStore']),
    navigateToSearchIcon() {
      this.$router.push({
        path: 'traceability/search',
        query: {
          typeOfSearch: TRACEABILITY_SEARCH_DATE,
          startDate: Moment(new Date()).clone().subtract(7, 'days').format("DD/MM/YYYY"),
          endDate:  Moment(new Date()).format("DD/MM/YYYY"),
        }
      })
    },
  },
}
</script>

<style lang="scss">
.subtitleRegular {
  overflow: inherit !important;
  width: 100% !important;
  max-width: 100% !important;
}

#traceability-search {
  overflow: inherit !important;
  z-index: 1 !important;
}
</style>
